module.exports = __webpack_public_path__ + "media/images/evaluation_count-637b8160ce396f934b238ec18cc7d0f2.svg";